<template>
  <div class="home">
    <div class="header">
      <add-companys @success="getList"></add-companys>
      <div style="float:right">
      </div>
    </div>
    <!-- content -->
    <div>
        <el-table size="mini" :data="userList"  border style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}">
        <el-table-column fixed type="index" width="50" label="序号" align="center"></el-table-column>
        <el-table-column prop="name" label="代账公司名" align="center"/>
        <el-table-column prop="userName" label="用户名" align="center"/>
        <el-table-column prop="password" label="密码" align="center"/>
        <el-table-column prop="mac" label="mac地址" min-width="140" align="center"/>
        <el-table-column fixed="right" label="操作" min-width="100" align="center">
            <template v-slot="scope">
            <el-button type="text" size="small" @click="edit(scope.row)">修改mac地址</el-button>
            <el-popconfirm
                confirm-button-text="确认"
                cancel-button-text="取消"
                icon="el-icon-info"
                icon-color="red"
                title="确认删除"
                @confirm="deleteUser(scope.row)"
            >
                <template #reference>
                <el-button type="text" size="small">删除</el-button>
                </template>
            </el-popconfirm>
            </template>
        </el-table-column>
        </el-table>
        <div class="pagination">
        <qzf-pagination v-show="userTotal>0" :total="userTotal" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
        </div>
    </div>
    <!-- 修改mac地址 -->
    <el-dialog v-model="dialogMacVisible" title="修改mac地址" width="30%" :before-close="handleClose">
      <el-select v-model="macValue" multiple placeholder="请选择mac地址" @change="changeValue" size="mini">
        <el-option v-for="item in options" :key="item.mac" :label="item.name+'-'+item.mac" :value="item.mac"></el-option>
      </el-select>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="mini" @click="dialogMacVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="confirm"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { userList, delUser ,zyDeviceList, saveOrg} from "@/api/ea";
import addCompanys from "@/components/addCompany";

export default {
  components: { addCompanys },
  name: 'admin',
  data() {
    return {
      userList: [],
      dialogMacVisible:false,
      formLabelWidth: "110px",
      userTotal: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      options:[],
      macValue:'',
      macId:undefined,
      macAddress:undefined
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList(){
      userList(this.listQuery).then(res=>{
        this.userList = res.data.data.list
        this.userTotal = res.data.data.total
      })
    },
    deleteUser(row){
      delUser([row]).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("删除成功")
          this.getList()
        }
      })
    },
    edit(row){
      this.macId = row.orgId
      this.macValue = row.mac?row.mac.split(','):[]
      this.dialogMacVisible = true
      zyDeviceList().then(res=>{
        this.options = res.data.data.list
      })
    },
    changeValue(val){
      this.macAddress = val.join(",")
    },
    confirm(){
      let params = {
        id:this.macId,
        mac:this.macAddress
      }
      console.log(params);
      saveOrg(params).then(res=>{
        if(res.data.msg == "success"){
          this.dialogMacVisible = false
          this.getList()
          this.$qzfMessage("修改成功")
        }
      })
    }
  },
  
}
</script>
<style lang="scss" scoped>
.input-set{
  width: 200px;
  margin-right: 10px;
}
.header{
  padding: 10px 10px 10px 0;
}
.pagination{
  text-align: right;
  margin-right: 26px;
  margin-top: 16px;
}
.input{
  width: 200px;
}
</style>